export default __webpack_public_path__ + "static/media/boomKlein.dd8cdbf0.jpg";